<audio controls>
  @for (source of sources; track i; let i = $index) {
    <source [src]="source.uri" [type]="source.mimetype">
  }
  Your browser does not support the audio element.
</audio>
